export default "__VITE_ASSET__pSS4n_SV__"